export const CUSTOM_META_FIELDS_CHANGED_EVENT = 'customMetaFieldsChanged';

export const notifyCustomMetaFieldsChanged = (ownerType, organizationId) => {
    window.dispatchEvent(new CustomEvent(CUSTOM_META_FIELDS_CHANGED_EVENT, {
        detail: organizationId == null ? {ownerType} : {ownerType, organizationId},
    }));
};

export const subscribeToCustomMetaFieldsChanged = ({ownerType, organizationId, onChange}) => {
    const listener = event => {
        if (event.detail?.ownerType !== ownerType) return;
        if (event.detail?.organizationId != null && event.detail.organizationId !== organizationId) return;
        onChange();
    };
    window.addEventListener(CUSTOM_META_FIELDS_CHANGED_EVENT, listener);
    return () => window.removeEventListener(CUSTOM_META_FIELDS_CHANGED_EVENT, listener);
};
